import PropTypes from "prop-types";
import { Card } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import "react-calendar/dist/Calendar.css";
import dayjs from "dayjs";

const ClickStatsChart = ({ data}) => {


  // Sort data by date to ensure chronological order
  const sortedData = Array.isArray(data)
    ? [...data].sort(
        (a, b) => dayjs(a.created_day).unix() - dayjs(b.created_day).unix()
      )
    : [];

  const options = {
    colors: ["#0D56EB", "#FFC107"], // Blue for Signups, Yellow for Conversions
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.2,
        gradientToColors: ["#0D56EB", "#FFC107"],
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 100],
      },
    },
    grid: {
      borderColor: "#393939",
      strokeDashArray: 0,
    },
    chart: {
      height: 350,
      type: "area",
      zoom: { enabled: true },
      toolbar: { show: false },
    },
    title: {
      align: "left",
      style: {
        color: "#FFFFFF",
        fontSize: "16px",
        fontWeight: "bold",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: sortedData.map((item) =>
        dayjs(item.created_day).format("DD-MM-YYYY")
      ),
      labels: {
        style: {
          colors: "#FFFFFF",
        },
      },
    },
    yaxis: {
      title: {
        text: "Signup's", // Match the new code and image
        style: {
          color: "#FFFFFF",
        },
      },
      labels: {
        style: {
          colors: "#FFFFFF",
        },
        formatter: (val) => Math.round(val).toString(),
      },
    },
    tooltip: {
      enabled: true,
      shared: true,
      followCursor: false,
      intersect: false,
      y: {
        formatter: (val) => Math.round(val).toString(),
      },
    },
    legend: {
      labels: {
        colors: "#FFFFFF",
      },
    },
  };

  const series = [
    {
      name: "Signups",
      type: "area",
      data: sortedData.map((item) => item.signups),
    },
    {
      name: "Conversions",
      type: "area",
      data: sortedData.map((item) => item.conversion),
    },
  ];



  return (
    <Card className="pushleads-chart">
      <div className="filter_wrapper">
        <p>Signups & Conversions</p>
      </div>

      <ReactApexChart
        className="reactChart_div"
        options={options}
        series={series}
        type="area"
        height={220}
      />
    </Card>
  );
};

ClickStatsChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      created_day: PropTypes.string.isRequired,
      clicks: PropTypes.number.isRequired,
      conversion: PropTypes.number.isRequired,
      outstanding_commission: PropTypes.number.isRequired,
      commission_amount: PropTypes.number.isRequired,
    })
  ).isRequired,
  params: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string,
  }).isRequired,
  setParams: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};


export default ClickStatsChart;
